import { useState } from "react";

/**
 * Hook for managing activity logs and decryption states
 */
export const useLogsState = () => {
  const [activeTab, setActiveTab] = useState("scanner");
  const [logs, setLogs] = useState([]);
  const [loadingLogs, setLoadingLogs] = useState(false);
  const [logsError, setLogsError] = useState(null);
  
  const [showDecryptModal, setShowDecryptModal] = useState(false);
  const [selectedLogForDecrypt, setSelectedLogForDecrypt] = useState(null);
  const [decryptingScript, setDecryptingScript] = useState(false);
  const [decryptDownloadUrl, setDecryptDownloadUrl] = useState(null);
  const [error, setError] = useState(null);

  return {
    // Tab management
    activeTab,
    setActiveTab,
    
    // Logs
    logs,
    setLogs,
    loadingLogs,
    setLoadingLogs,
    logsError,
    setLogsError,
    
    // Decrypt modal
    showDecryptModal,
    setShowDecryptModal,
    selectedLogForDecrypt,
    setSelectedLogForDecrypt,
    decryptingScript,
    setDecryptingScript,
    decryptDownloadUrl,
    setDecryptDownloadUrl,
    
    // General error
    error,
    setError,
  };
};
